import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight';
import { faArrowUp } from '@fortawesome/pro-solid-svg-icons/faArrowUp';
import { faBars } from '@fortawesome/pro-solid-svg-icons/faBars';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCircleArrowRight } from '@fortawesome/pro-solid-svg-icons/faCircleArrowRight';
import { faDownload } from '@fortawesome/pro-solid-svg-icons/faDownload';
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight';
import { faChevronsRight } from '@fortawesome/pro-solid-svg-icons/faChevronsRight';
import { faSquarePlus } from '@fortawesome/pro-solid-svg-icons/faSquarePlus';
import { faCircleQuestion } from '@fortawesome/pro-solid-svg-icons/faCircleQuestion';
import { faCircleRight } from '@fortawesome/pro-solid-svg-icons/faCircleRight';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons/faCircleInfo';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons/faCircleExclamation';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons/faFacebookSquare';
import { faFilePdf } from '@fortawesome/pro-solid-svg-icons/faFilePdf';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faBan } from '@fortawesome/pro-solid-svg-icons/faBan';
import { faFlag } from '@fortawesome/pro-solid-svg-icons/faFlag';
import { faGlobe } from '@fortawesome/pro-solid-svg-icons/faGlobe';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { faMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlass';
import { faPencil } from '@fortawesome/pro-solid-svg-icons/faPencil';
import { faPhone } from '@fortawesome/pro-solid-svg-icons/faPhone';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle';
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar';
import { faTableList } from '@fortawesome/pro-solid-svg-icons/faTableList';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faXmark } from '@fortawesome/pro-solid-svg-icons/faXmark';
import { faFilm } from '@fortawesome/pro-solid-svg-icons/faFilm';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faInstagramSquare } from '@fortawesome/free-brands-svg-icons/faInstagramSquare';
import domready from 'domready';

declare global {
    // for some strange reason, this is not (yet) part of @fortawesome/fontawesome-common-types
    interface Window { FontAwesomeConfig: {
            searchPseudoElements: boolean
        }
    }
}

domready(() => {
    library.add(
        faArrowRight,
        faArrowUp,
        faBars,
        faCaretDown,
        faCircleArrowRight,
        faAngleRight,
        faChevronsRight,
        faSquarePlus,
        faCircleQuestion,
        faCircleRight,
        faCircleInfo,
        faCircleExclamation,
        faDownload,
        faEnvelope,
        faFacebookSquare,
        faFilePdf,
        faCheck,
        faBan,
        faFlag,
        faGlobe,
        faLinkedin,
        faMagnifyingGlass,
        faPencil,
        faPhone,
        faQuestionCircle,
        faSearch,
        faTableList,
        faTwitter,
        faStar,
        faUser,
        faXmark,
        faFilm,
        faYoutube,
        faInstagramSquare
    );

    window.FontAwesomeConfig.searchPseudoElements = true;

    void dom.i2svg();
});
